import React from "react";
import { useSelector } from "react-redux";
import classes from "./TabLinks.module.scss";

const TabLinks = ({ tabs, activeTab, setActiveTab, gap = "2" }) => {
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  return (
    <div
      className={classes.tabLinks}
      style={{
        gap: gap + "rem",
      }}
    >
      {tabs.map((tab) => {
        return (
          <div
            key={tab.id}
            className={classes.tabLinks__tabLink}
            onClick={() => {
              if (!tab?.disabled) {
                setActiveTab(tab.id);
              }
            }}
            style={{
              color: tab.id === activeTab ? colors.theme : "#404040",
              opacity: tab.id === activeTab ? 1 : tab?.disabled ? 0.3 : 0.5,
              borderBottom:
                tab.id === activeTab ? `0.4rem solid ${colors.theme}` : "0rem",
              cursor: tab?.disabled ? "no-drop" : "pointer",
            }}
          >
            {tab?.icon && tab?.icon(tab.id === activeTab && colors.theme)}
            <div>{tab?.name}</div>
          </div>
        );
      })}
    </div>
  );
};

export default TabLinks;
